module.exports = __webpack_public_path__ + "static/img/kjdy01.61c7597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy01.png
// module id = 52
// module chunks = 0